import { Clock, CheckCircle2, XCircle, Wallet } from "lucide-react";
import { useLang } from "@/context/LangContext";

const STYLES = {
  awaiting: "bg-sky-100 text-sky-900 border-sky-300 dark:bg-sky-950/80 dark:text-sky-300 dark:border-sky-800",
  pending: "bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-950/80 dark:text-amber-300 dark:border-amber-800",
  approved: "bg-emerald-100 text-emerald-900 border-emerald-300 dark:bg-emerald-950/80 dark:text-emerald-300 dark:border-emerald-800",
  rejected: "bg-rose-100 text-rose-900 border-rose-300 dark:bg-rose-950/80 dark:text-rose-300 dark:border-rose-800",
};
const ICONS = { awaiting: Wallet, pending: Clock, approved: CheckCircle2, rejected: XCircle };

export const StatusBadge = ({ status, large, testId }) => {
  const { t } = useLang();
  const Icon = ICONS[status] || Clock;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold ${STYLES[status]} ${large ? "px-4 py-2 text-base" : "px-2.5 py-1 text-xs"}`}
    >
      <Icon className={large ? "h-5 w-5" : "h-3.5 w-3.5"} />
      {t(`status_${status}`)}
    </span>
  );
};
